var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35168 3.3335H5.23814C4.18617 3.3335 3.33337 4.18629 3.33337 5.23826V7.14302C3.33337 12.4029 7.59733 16.6668 12.8572 16.6668H14.7619C15.8139 16.6668 16.6667 15.814 16.6667 14.7621V13.4459C16.6667 13.0852 16.4629 12.7554 16.1402 12.5941L13.8394 11.4436C13.321 11.1844 12.6932 11.4445 12.5099 11.9943L12.2263 12.8451C12.0427 13.3961 11.4774 13.7242 10.9077 13.6103C8.62794 13.1543 6.84589 11.3723 6.38993 9.09246C6.27601 8.52285 6.60406 7.95755 7.15514 7.77386L8.21098 7.42191C8.6831 7.26454 8.95446 6.77021 8.83376 6.28742L8.27563 4.05489C8.16964 3.63092 7.7887 3.3335 7.35168 3.3335Z",
    stroke: "#646464"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.727c9e1a89803b93572651c7b0bd9e4d.svg";
export { ForwardRef as ReactComponent };